import { render } from "./UnassignedTasksCard.vue?vue&type=template&id=432802bf&scoped=true"
import script from "./UnassignedTasksCard.vue?vue&type=script&lang=js"
export * from "./UnassignedTasksCard.vue?vue&type=script&lang=js"

import "./UnassignedTasksCard.vue?vue&type=style&index=0&id=432802bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432802bf"]])

export default __exports__